import TR from 'utils/TR';
import { Chart } from 'chart.js';
import AbnormalCircle from 'components/common/AbnormalCircle';
import HBox from 'components/common/HBox';
import Segment from 'components/common/Segment';
import VBox from 'components/common/VBox';
import useRect from 'hooks/common/useRect';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';
import { numberWithComma } from 'utils/number';
import HalfDoughnutChart from '../../charts/HalfDoughnutChart';
import DoubleBarChart from 'components/charts/DoubleBarChart';
import Dot from 'components/common/Dot';

export default function ExerciseBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    daily_avg_step_cnt = 0,
    daily_avg_burned_calorie = 0,
    daily_avg_step_time = 0,
    daily_avg_2hr_after_meal_step_time = 0,
    daily_avg_2hr_after_meal_step_time_rate = 0,

    active_bf_day_avg_step_cnt = 0,

    recommend_daily_avg_step_cnt = 0,
    recommend_daily_avg_burned_calorie = 0,

    postprand_avg_step_cnt = 0,
    postprand_avg_burned_calorie = 0,
    active_bf_day_avg_burn_cal = 0,
  } = data || {};

  const [steps, steps_min, steps_max] = React.useMemo(() => {
    return [
      [[{ label: 'last', value: active_bf_day_avg_step_cnt }], [{ label: 'average', value: daily_avg_step_cnt }]],
      Math.min(recommend_daily_avg_step_cnt, active_bf_day_avg_step_cnt, daily_avg_step_cnt),
      Math.max(recommend_daily_avg_step_cnt, active_bf_day_avg_step_cnt, daily_avg_step_cnt)
    ];
  }, [active_bf_day_avg_step_cnt, daily_avg_step_cnt, recommend_daily_avg_step_cnt]);

  const [calories, calories_min, calories_max] = React.useMemo(() => {
    return [
      [[{ label: 'last', value: active_bf_day_avg_burn_cal }], [{ label: 'average', value: daily_avg_burned_calorie }]],
      Math.min(recommend_daily_avg_burned_calorie, active_bf_day_avg_burn_cal, daily_avg_burned_calorie),
      Math.max(recommend_daily_avg_burned_calorie, active_bf_day_avg_burn_cal, daily_avg_burned_calorie)
    ];
  }, [active_bf_day_avg_burn_cal, daily_avg_burned_calorie, recommend_daily_avg_burned_calorie]);

  // const max = React.useMemo(() => {
  //   return Math.max(...[
  //     active_bf_day_avg_step_cnt,
  //     postprand_avg_step_cnt,
  //     active_bf_day_avg_step_cnt,
  //     postprand_avg_burned_calorie,
  //     recommend_daily_avg_step_cnt,
  //     recommend_daily_avg_burned_calorie,
  //   ]);
  // }, [active_bf_day_avg_step_cnt, postprand_avg_burned_calorie, postprand_avg_step_cnt, recommend_daily_avg_burned_calorie, recommend_daily_avg_step_cnt]);

  return (
    <Segment {...ex(['OverviewBox', 'ExerciseBox'], props)}>
      <HBox full>
        <VBox
          full
          {...ex('BoxContainer')}
        >
          <div>
            <div {...ex('BoxItem')}>
              {T('식후 평균 걸음수')}
            </div>
            <HBox {...ex('BoxValueContainer')}>
              <div {...ex('BoxValue')}>
                {numberWithComma(postprand_avg_step_cnt)}
              </div>
              <div {...ex('BoxUnit')}>
                {T('보')}
              </div>
            </HBox>
          </div>
          <div>
            <div {...ex('BoxItem')}>
              {T('식후 평균 소모칼로리')}
            </div>
            <HBox {...ex('BoxValueContainer')}>
              <div {...ex('BoxValue')}>
                {numberWithComma(postprand_avg_burned_calorie)}
              </div>
              <div {...ex('BoxUnit')}>
                {T('kcal')}
              </div>
            </HBox>
          </div>
        </VBox>
        <VBox full>
          <HBox {...ex('OverviewBoxLegends')}>
            <Dot {...{ color: '#ff995a' }}>
              <div>
                {T('일권장량')}
              </div>
            </Dot>
            <Dot {...{ color: '#AAAAAA' }}>
              <div>
                {T('지난 기간')}
              </div>
            </Dot>
            <Dot {...{ color: '#1D82FF' }}>
              <div>
                {T('일평균')}
              </div>
            </Dot>
          </HBox>
          <HBox full>
            <VBox>
              <DoubleBarChart
                {...{
                  max: steps_max < calories_max ? (steps_max + calories_max) / 2 : steps_max,
                  min: steps_min * 0.9,
                  values: steps,
                  recommended: recommend_daily_avg_step_cnt,
                  unit: T('보'),
                }}
              />
              <div {...ex('ChartLabel')}>
                {T('걸음수 (보)')}
              </div>
            </VBox>
            <VBox>
              <DoubleBarChart
                {...{
                  max: steps_max > calories_max ? (steps_max + calories_max) / 2 : steps_max,
                  min: calories_min * 0.9,
                  values: calories,
                  recommended: recommend_daily_avg_burned_calorie,
                  unit: T('kcal'),
                }}
              />
              <div {...ex('ChartLabel')}>
                {T('소모칼로리 (kcal)')}
              </div>
            </VBox>
          </HBox>
        </VBox>
      </HBox>
    </Segment>
  );
}
